import { useEffect, useState } from 'react';

import { getFaucetTransfers } from 'src/pages/admin/services/officialVaultService';

import { FaucetTransferView, faucetTransferViews } from './helpers';

/**
 * The vault's recent faucet requests (newest first), read when `vaultId` is set and `enabled`. The send reply is
 * always DRAFT, so this is where the operator sees a FAILED request and why. A read that fails (the faucet off on this
 * stage, no `vault:faucet` read, the engine down) leaves the list empty and says so with `error`; it never blocks
 * the drawer.
 */
export const useFaucetTransfers = (vaultId: string | null, enabled: boolean) => {
  const [rows, setRows] = useState<FaucetTransferView[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    setRows([]);
    setError(false);
    if (!vaultId || !enabled) {
      setLoading(false);
      return undefined;
    }
    let live = true;
    setLoading(true);
    getFaucetTransfers(vaultId)
      .then((records) => {
        if (live) setRows(faucetTransferViews(records));
      })
      .catch(() => {
        if (live) setError(true);
      })
      .finally(() => {
        if (live) setLoading(false);
      });
    return () => {
      live = false;
    };
  }, [vaultId, enabled]);
  return { rows, loading, error };
};
